














import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatableV2.vue'
import AppForm from '@core/components/AppForm.vue'
import AppSwitch from '@core/components/AppSwitch.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { options } from '@master/model/options/Options'
import { ClientPolicyReportDTO } from '@core/pages/new-business-register/components/policy/model/ClientPolicyReportDTO'
import { ClientPolicyReportRequestDTO } from '@core/pages/new-business-register/api'
import { SystemRole } from '@master/enum/SystemRoleEnum'
import { clone, sortBy } from 'lodash'
import { SharedVariable } from '@core/model/SharedVariable'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import { IProjectInfo } from '@master/config/IProjectInfo'

type AdvisersOptions = {
  label: string;
  value: string | boolean | number;
  systemRole: string;
}
const SELECT_ALL = 'select-all'
@Component({
  components: {
    AppDatatable,
    AppForm,
    AppSwitch
  }
})

export default class ReportDashboardComponent extends Vue {
  @Prop({ default: () => [] }) companyOptions: options[]
  @Prop({ default: () => [] }) adviserOptions: AdvisersOptions[]

  private uiService: UIService
  private selectedAdvisers: string[] = []
  private selectedIssuers: string[] = []

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private projectInfo: IProjectInfo

  adHocReportModel: ClientPolicyReportRequestDTO = new ClientPolicyReportDTO()

  selectedTab = 'Production Report Generator'

  get ReportEnum () {
    return {
      [ClientPolicyReportRequestDTO.type.PRODUCTION_MTD_PERSONAL]: 'Production MTD Personal',
      [ClientPolicyReportRequestDTO.type.PRODUCTION_YTD_PERSONAL]: 'Production YTD Personal',
      [ClientPolicyReportRequestDTO.type.PRODUCTION_MTD_SUPERVISOR]: 'Production MTD Supervisor',
      [ClientPolicyReportRequestDTO.type.PRODUCTION_YTD_SUPERVISOR]: 'Production YTD Supervisor',
      [ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_PERSONAL]: 'Production Custom - Personal',
      [ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_SUPERVISOR]: 'Production Custom - Supervisor'
    }
  }

  get currentSystemRole () {
    return this.$store.getters.currentUser.systemrole
  }

  get isCustomProduct () {
    return this.adHocReportModel.type === ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_PERSONAL ||
    this.adHocReportModel.type === ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_SUPERVISOR
  }

  get isSupervisorProduct () {
    return this.adHocReportModel.type === ClientPolicyReportRequestDTO.type.PRODUCTION_MTD_SUPERVISOR || this.adHocReportModel.type === ClientPolicyReportRequestDTO.type.PRODUCTION_YTD_SUPERVISOR || this.adHocReportModel.type === ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_SUPERVISOR
  }

  get isPersonalProduct () {
    return this.adHocReportModel.type === ClientPolicyReportRequestDTO.type.PRODUCTION_MTD_PERSONAL || this.adHocReportModel.type === ClientPolicyReportRequestDTO.type.PRODUCTION_YTD_PERSONAL ||
    this.adHocReportModel.type === ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_PERSONAL
  }

  get filteredAdviserDropList () {
    // only want adviser, supervisor, director
    const array = this.adviserOptions.filter(user => user.systemRole === SystemRole.Adviser || user.systemRole === SystemRole.Supervisor || user.systemRole === SystemRole.Director)
    if (this.isSupervisorProduct) {
      return this.getSupervisorProductAdviserOption(array)
    }
    if (this.isPersonalProduct) {
      return this.getPersonalProductAdviserOption(array)
    }
    return array
  }

  getPersonalProductAdviserOption (fullAdviserList: AdvisersOptions[]) {
    const currentUser = this.findCurrentUserFromList(fullAdviserList)

    switch (this.currentSystemRole) {
      case SystemRole.OpsStaff:
        return fullAdviserList
      case SystemRole.Director: {
        const applicableArray = fullAdviserList.filter(user => user.systemRole === SystemRole.Supervisor || user.systemRole === SystemRole.Adviser)

        if (currentUser) {
          applicableArray.push(currentUser)
        }
        return sortBy(applicableArray, user => user.label)
      }
      case SystemRole.Supervisor: {
        const applicableArray = fullAdviserList.filter(user => user.systemRole === SystemRole.Adviser)
        if (currentUser) {
          applicableArray.push(currentUser)
        }
        return sortBy(applicableArray, user => user.label)
      }
      case SystemRole.Adviser: {
        return [currentUser] // adviser only can generate his own report
      }
      default:
        return []
    }
  }

  getSupervisorProductAdviserOption (fullAdviserList: AdvisersOptions[]) {
    const currentUser = this.findCurrentUserFromList(fullAdviserList)
    switch (this.currentSystemRole) {
      case SystemRole.OpsStaff:
        return fullAdviserList.filter(user => user.systemRole === SystemRole.Director || user.systemRole === SystemRole.Supervisor)
      case SystemRole.Director: {
        const applicableArray = fullAdviserList.filter(user => user.systemRole === SystemRole.Supervisor)
        if (currentUser) {
          applicableArray.push(currentUser)
        }
        return sortBy(applicableArray, user => user.label)
      }
      case SystemRole.Supervisor: {
        return [currentUser] // supervisor role can prints his own supervisor group
      }
      default:
        return []
    }
  }

  private findCurrentUserFromList (fullAdviserList: AdvisersOptions[]) {
    const currentUserOid = this.$store.getters.currentUser.accountID
    return fullAdviserList.find(user => user.value === currentUserOid)
  }

  async dashboardOptionSelected (option: string) {
    this.selectedTab = option
  }

  reportOptions () {
    // if system role is admin, director, supervisor, show Personal, supervisor, custom personal, custom supervisor
    // if system rile is adviser, show personal, custom personal
    let optionsValue = []
    if (SystemRole.Adviser === this.currentSystemRole) {
      optionsValue = [ClientPolicyReportRequestDTO.type.PRODUCTION_MTD_PERSONAL, ClientPolicyReportRequestDTO.type.PRODUCTION_YTD_PERSONAL, ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_PERSONAL]
    } else if (this.currentSystemRole === SystemRole.Director || this.currentSystemRole === SystemRole.Supervisor || this.currentSystemRole === SystemRole.OpsStaff) {
      optionsValue = [ClientPolicyReportRequestDTO.type.PRODUCTION_MTD_PERSONAL, ClientPolicyReportRequestDTO.type.PRODUCTION_YTD_PERSONAL,
        ClientPolicyReportRequestDTO.type.PRODUCTION_MTD_SUPERVISOR, ClientPolicyReportRequestDTO.type.PRODUCTION_YTD_SUPERVISOR, ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_PERSONAL, ClientPolicyReportRequestDTO.type.PRODUCTION_REPORT_CUSTOM_SUPERVISOR]
    }

    return [{ label: '', value: '' }].concat(optionsValue.map(value => {
      return {
        label: this.ReportEnum[value],
        value: value
      }
    }))
  }

  get reportStructure (): FormStructure<ClientPolicyReportRequestDTO> {
    return [
      {
        label: 'Report Selection',
        key: 'type',
        classes: ['colspan'],
        options: this.reportOptions(),
        onChange: () => {
          this.adHocReportModel.startDate = undefined
          this.adHocReportModel.endDate = undefined
          this.selectedAdvisers = []
          this.selectedIssuers = []
        }
      },
      {
        label: 'Issuer',
        type: 'multi',
        options: [{ label: 'Select All', value: SELECT_ALL } as options].concat(this.companyOptions),
        model: {
          get: () => {
            return this.selectedIssuers
          },
          set: (newVal) => {
            const selectedArray = this.handleMultiSelectAction(this.selectedIssuers, newVal, this.companyOptions)
            this.selectedIssuers = clone(selectedArray)
          }
        }
      },
      {
        label: 'Advisers',
        type: 'multi',
        show: this.currentSystemRole !== SystemRole.Adviser && !(this.isSupervisorProduct && this.currentSystemRole === SystemRole.Supervisor),
        options: [{ label: 'Select All', value: SELECT_ALL, systemRole: '' } as AdvisersOptions].concat(this.filteredAdviserDropList),
        model: {
          get: () => {
            return this.selectedAdvisers
          },
          set: (newVal) => {
            const selectedArray = this.handleMultiSelectAction(this.selectedAdvisers, newVal, this.filteredAdviserDropList)
            this.selectedAdvisers = clone(selectedArray)
          }
        }
      },
      {
        label: 'Filter Date By',
        type: 'smart',
        key: 'dateFilteringSelection',
        options: [
          { label: 'NBR status date', value: 'opsApprovalDate' },
          { label: `${this.projectInfo.personalFinancialReview || 'KYC'}/${this.projectInfo.electronicFormName || 'E-KYC'} Date`, value: 'kycSubmissionTimestamp' }]
      },
      {
        label: 'From Date',
        key: 'startDate',
        type: 'date',
        classes: ['first-column'],
        show: this.isCustomProduct
      },
      {
        label: 'To Date',
        key: 'endDate',
        type: 'date',
        show: this.isCustomProduct
      }
    ]
  }

  handleMultiSelectAction (oldVal, newVal, fullList) {
    let selectedArray = []
    if (newVal.length === 1 && newVal.includes(SELECT_ALL)) {
      fullList.forEach(adviser => {
        selectedArray.push(adviser.value as string)
      })
      selectedArray.push(...newVal)
    } else if (oldVal.includes(SELECT_ALL) && !newVal.includes(SELECT_ALL)) {
      selectedArray = []
    } else if (oldVal.includes(SELECT_ALL) && newVal.includes(SELECT_ALL)) {
      const index = newVal.indexOf(SELECT_ALL)
      newVal.splice(index, 1)
      selectedArray = newVal
    } else if (!oldVal.includes(SELECT_ALL) && !newVal.includes(SELECT_ALL)) {
      if (newVal.length === fullList.length - 1) {
        selectedArray = [SELECT_ALL].concat(newVal)
      } else {
        selectedArray = newVal
      }
    }
    return selectedArray
  }

  async generateReport () {
    if (!this.adHocReportModel.type) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Report Selection is empty.'
      })
      return
    }
    if (this.isCustomProduct && !this.adHocReportModel.endDate && !this.adHocReportModel.startDate) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Date Range is required.'
      })
      return
    }

    if (this.selectedAdvisers.length === 0) {
      // if the adviser list is not selected, print all based on the condition
      this.adHocReportModel.advisersList = this.filteredAdviserDropList.map(adviser => adviser.value)
    } else {
      this.adHocReportModel.advisersList = clone(this.selectedAdvisers)
      const index = this.adHocReportModel.advisersList.indexOf(SELECT_ALL)
      if (index > -1) {
        this.adHocReportModel.advisersList.splice(index, 1)
      }
    }

    if (this.selectedIssuers.length === 0) {
      this.adHocReportModel.issuers = this.companyOptions.map(company => company.value)
    } else {
      this.adHocReportModel.issuers = clone(this.selectedIssuers)
      const index = this.adHocReportModel.issuers.indexOf(SELECT_ALL)
      if (index > -1) {
        this.adHocReportModel.issuers.splice(index, 1)
      }
    }
    this.$emit('generate-report', this.adHocReportModel)
  }

  mounted () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
  }
}
